import React from "react";
import { Container } from "react-bootstrap";
import { ContentWrapper, Sida } from "./ContentStyles";
import FAQ from "../pages/Faq";
import "./FaqPage.scss";
import { FaRegQuestionCircle } from "react-icons/fa";
import { Branding, Helmetx } from '../services/misc';

const FaqPage = () => {
    return (
        <>
            <Helmetx />
            <ContentWrapper className="faq-page">
                <div className="faq-page__bg" aria-hidden="true">
                    <div className="faq-page__blob faq-page__blob--a" />
                    <div className="faq-page__blob faq-page__blob--b" />
                    <div className="faq-page__blob faq-page__blob--c" />
                </div>

                <Container>
                    <Sida className="faq-page__layout">
                        <section className="faq-card" aria-labelledby="faq-page-title">
                            {/* Liten pill/etikett */}
                            <div className="faq-pill">
                                <span className="faq-pill__icon" aria-hidden="true"><FaRegQuestionCircle /></span>
                                <span className="faq-pill__text">FAQ</span>
                            </div>
                            <h1 id="faq-page-title" className="faq-page__title">Vanliga frågor och svar</h1>
                            <p className="faq-page__intro">
                                Här hittar du svar på vanliga frågor om hur Närbutik.se fungerar,<br></br> hur du startar en obemannad butik och vilka abonnemang som finns.
                            </p>
                            {/* Er komponent */}
                            <FAQ />
                        </section>
                    </Sida>
                </Container>
            </ContentWrapper>
        </>
    );
};

export default FaqPage;
